import { VCard } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    {
      staticClass: "ma-0 pa-0",
      attrs: { flat: "", color: "rgba(255, 0, 0, 0)" },
    },
    [
      _c(VSwitch, {
        attrs: { label: "DotMode" },
        model: {
          value: _vm.dotModeData,
          callback: function ($$v) {
            _vm.dotModeData = $$v
          },
          expression: "dotModeData",
        },
      }),
      _vm._v(" "),
      !_vm.dotModeData
        ? _c(
            VTextarea,
            _vm._b(
              {
                model: {
                  value: _vm.json,
                  callback: function ($$v) {
                    _vm.json = $$v
                  },
                  expression: "json",
                },
              },
              "VTextarea",
              _vm.textAreaProps,
              false
            )
          )
        : _c(
            VTextarea,
            _vm._b(
              {
                model: {
                  value: _vm.dotString,
                  callback: function ($$v) {
                    _vm.dotString = $$v
                  },
                  expression: "dotString",
                },
              },
              "VTextarea",
              _vm.textAreaProps,
              false
            )
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }